import { DeleteOutlineIcon } from '@carboncopyco/icons';
import { Button, Modal, Spacer, TextBase } from '@carboncopyco/ui';
import { useTourCapturePageProps } from './TourCapturePageContext';

interface RestartCaptureFramesModalProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title: string;
  description: string;
  confirmButtonLabel: string;
  showTrashIcon?: boolean;
}

function RestartCaptureFramesModal({
  open,
  onConfirm,
  onClose,
  title,
  description,
  confirmButtonLabel,
  showTrashIcon = true,
}: RestartCaptureFramesModalProps) {
  const { desktopHooks } = useTourCapturePageProps();
  desktopHooks?.useFocusModalAppService(open);

  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
      locked
      closeOnlyFromCloseIcon
    >
      <Spacer amount={2.5} />
      <div className={'w-ds-434'}>
        <TextBase label={description} />
      </div>
      <Spacer amount={3} />
      <div className="w-full flex flex-row-reverse">
        <Button
          label={confirmButtonLabel}
          leftIcon={showTrashIcon && <DeleteOutlineIcon />}
          danger
          onClick={onConfirm}
        />
        <Spacer amount={0.5} />
        <Button
          onClick={onClose}
          key="cancel"
          label="Cancel"
          link
          secondary
        />
      </div>
    </Modal>
  );
}

export default RestartCaptureFramesModal;
